import styles from './Card.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { UNSAFE_LinkContext } from '../link/LinkContext.js';
import { Link } from '../link/Link.js';
import classNames from 'clsx';

function ActionCard(props) {
  const {
    children,
    variant = 'outline',
    bleed = 'default',
    size = 'default',
    className: callerClassName,
    tag,
    href,
    hrefType,
    rel,
    target,
    disabled,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover
  } = props;
  const interactiveProps = useActionCard(props);
  const className = classNames('dsx-component', callerClassName, styles['card'], styles['interactive'], styles[`bleed-${bleed}`], styles[`size-${size}`], styles[`variant-${variant}`], disabled && styles['disabled'], UNSAFE_hover && styles['hover'], UNSAFE_active && styles['active'], UNSAFE_focus && styles['focus']);
  if (href) {
    return /*#__PURE__*/jsx(UNSAFE_LinkContext.Provider, {
      value: {
        variant: 'UNSAFE_unset'
      },
      children: /*#__PURE__*/jsx(Link, {
        href,
        hrefType,
        rel,
        target,
        className: className,
        "data-dsx--card": tag,
        children: children
      })
    });
  }
  return /*#__PURE__*/jsx("div", {
    ...interactiveProps,
    className: className,
    "data-dsx--card": tag,
    children: children
  });
}
function useActionCard(props) {
  const {
    disabled
  } = props;
  const enabled = !disabled;
  function onClick() {
    enabled && props.onClick?.();
  }
  function onKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      enabled && props.onClick?.();
    }
  }
  function onFocus() {
    enabled && props.onFocus?.();
  }
  function onBlur() {
    enabled && props.onBlur?.();
  }
  return {
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    tabIndex: enabled ? 0 : undefined
  };
}

export { ActionCard };
